import { useState, useRef, useCallback } from "react";

/**
 * Draggable before/after image comparison slider.
 * - Hover/touch the divider to compare the two images
 * - Uses clip-path on the "after" image to reveal as user drags
 */
export const BeforeAfterSlider = ({ before, after, testid }) => {
  const [pos, setPos] = useState(50); // percent
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = clientX - rect.left;
    const pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setPos(pct);
  }, []);

  const handleDown = (e) => {
    dragging.current = true;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    update(clientX);
  };
  const handleMove = (e) => {
    if (!dragging.current) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    update(clientX);
  };
  const handleUp = () => { dragging.current = false; };

  return (
    <div
      ref={containerRef}
      className="relative w-full h-full select-none overflow-hidden bg-as-black cursor-ew-resize"
      onMouseDown={handleDown}
      onMouseMove={handleMove}
      onMouseUp={handleUp}
      onMouseLeave={handleUp}
      onTouchStart={handleDown}
      onTouchMove={handleMove}
      onTouchEnd={handleUp}
      data-testid={testid}
    >
      {/* BEFORE image (full) */}
      <img
        src={before}
        alt="Antes"
        className="absolute inset-0 w-full h-full object-cover"
        draggable={false}
      />
      <span className="absolute top-3 left-3 z-20 bg-as-black/80 text-white as-label text-[10px] px-2 py-1">
        ANTES
      </span>

      {/* AFTER image (clipped) */}
      <div
        className="absolute inset-0 overflow-hidden"
        style={{ clipPath: `inset(0 0 0 ${pos}%)` }}
      >
        <img
          src={after}
          alt="Después"
          className="absolute inset-0 w-full h-full object-cover"
          draggable={false}
        />
        <span className="absolute top-3 right-3 bg-as-green text-as-black as-label text-[10px] px-2 py-1">
          DESPUÉS
        </span>
      </div>

      {/* Divider line + handle */}
      <div
        className="absolute top-0 bottom-0 w-[3px] bg-as-green pointer-events-none"
        style={{ left: `${pos}%`, transform: "translateX(-50%)" }}
      >
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-9 h-9 bg-as-green text-as-black flex items-center justify-center font-bold shadow-lg">
          <span className="text-lg leading-none">⇆</span>
        </div>
      </div>
    </div>
  );
};
